import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import capabiliaLogo from '../../assets/capabilia-logo.png';
import { NAV_LINKS, CONTACT_MAILTO, CAPABILIA_GREEN } from './landingConstants';

const logoStyleGreen = {
  filter: 'invert(1) sepia(1) saturate(5) hue-rotate(120deg) brightness(0.8)'
};

export const LandingHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100" data-testid="landing-header">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center gap-3" data-testid="landing-logo-link">
          <img src={capabiliaLogo} alt="Capabilia" style={{ width: 36, height: 36, ...logoStyleGreen }} />
          <div className="leading-tight">
            <p className="font-manrope font-bold text-base text-gray-900">Persistencia 360</p>
            <p className="text-[11px] text-gray-500">by Capabilia</p>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-testid={`landing-nav-${link.href.replace('#', '')}`}>
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/login"
            className="text-sm font-semibold px-4 py-2 rounded-full text-gray-700 hover:text-gray-900 transition-colors"
            data-testid="landing-login-btn"
          >
            Ingresar
          </Link>
          <a
            href={CONTACT_MAILTO}
            className="text-sm font-semibold px-5 py-2 rounded-full text-white transition-transform hover:scale-105"
            style={{ backgroundColor: CAPABILIA_GREEN }}
            data-testid="landing-contact-btn"
          >
            Contactanos
          </a>
        </div>

        <button
          className="md:hidden p-2 text-gray-700"
          onClick={() => setMenuOpen((v) => !v)}
          data-testid="landing-mobile-menu-btn"
          aria-label="Abrir menú"
        >
          {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 space-y-4" data-testid="landing-mobile-menu">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="block text-sm font-medium text-gray-700"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <div className="flex flex-col gap-3 pt-2">
            <Link to="/login" className="text-sm font-semibold text-gray-700" onClick={() => setMenuOpen(false)}>
              Ingresar
            </Link>
            <a
              href={CONTACT_MAILTO}
              className="text-sm font-semibold text-center px-5 py-2 rounded-full text-white"
              style={{ backgroundColor: CAPABILIA_GREEN }}
            >
              Contactanos
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
